'use client';

import { pushTimerThreeMin } from '@/lib/analytics';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const DELAY_MS = 3 * 60 * 1000;

export function useAnalyticsTimerThreeMin() {
  const pathname = usePathname();

  useEffect(() => {
    const id = window.setTimeout(() => {
      pushTimerThreeMin();
    }, DELAY_MS);
    return () => window.clearTimeout(id);
  }, [pathname]);
}
